import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import apiClient from "common/src/api/ApiClient";
import {getKey} from "../../utils/InfiniteScroleUtil";

const datasetAPI = createSlice({
   name: 'dataset',
   initialState: {
       list: [],
       loading: false,
       loadingById: {
           [getKey(null)] : false
       },
   },
    reducers: {
      clearDatasetDetails: (state, action) => {
          state.details = null;
          state.loadingDetails = false;
      },
        clearDatasetList: (state) => {
            state.list = {};
            state.loading = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDatasetPage.pending, (state, action) => {
                state.loading = true;
            }).addCase(fetchDatasetPage.fulfilled, (state, action) => {
                state.list = action.payload;
                state.loading = false;
            })
            .addCase(fetchDatasetPage.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchDatasetDetails.pending, (state, action) => {
                if (!state.loadingById) {
                    state.loadingById = {};
                }
                if (action?.meta.arg.id) {
                    state.loadingById[action?.meta.arg.id] = true;
                }
                state.loadingDetails = true;

            })
            .addCase(fetchDatasetDetails.rejected, (state, action) => {
                if (!state.loadingById) {
                    state.loadingById = {};
                }
                if (action?.meta.arg.id) {
                    state.loadingById[action.meta.arg.id] = false;
                }
                state.loadingDetails = false;

            })
            .addCase(fetchDatasetDetails.fulfilled, (state, action) => {
                state.details = action.payload;
                state[action.payload.id] = action.payload;

                if (!state.loadingById) {
                    state.loadingById = {};
                }
                if (action?.meta.arg.id) {
                    state.loadingById[action.meta.arg.id] = false;
                } else {
                    state.loadingById[action.payload.id] = false
                }
                state.loadingDetails = false;
            })
            .addCase(createDatasetDetails.fulfilled, (state, action) => {
                state.details = action.payload;
                state[action.payload.id] = action.payload;

            })
            .addCase(updateDatasetDetails.fulfilled, (state, action) => {
                state.details = action.payload;
                state[action.payload.id] = action.payload;
            })
            .addCase(publishDataset.fulfilled, (state, action) => {
                state.details = action.payload;
                state[action.payload.id] = action.payload;
            })
            .addCase(deActivateDataset.fulfilled, (state, action) => {
                state.details = action.payload;
                state[action.payload.id] = action.payload;
            })
            .addCase(reActivateDataset.fulfilled, (state, action) => {
                state[action.payload.id] = action.payload;
                state.details = action.payload;
            })

            .addCase(deleteDataset.fulfilled, (state, action) => {
                if (state[action.payload.id]) {
                    delete state[action.payload.id];
                    delete state.details;
                }
            })
    }
});

export const fetchDatasetPage = createAsyncThunk(
    "dataset/fetch/page",
    async ({page, filter, sort}) => {
       const response = await apiClient.get(`/api/v1/dataset`, null, page, filter, sort);
       return response.data.payload
    }
);

export const fetchDatasetDetails = createAsyncThunk(
    "dataset/fetch/details",
    async (id) => {
        const response = await apiClient.get(`/api/v1/dataset/${id}`);
        return response.data.payload
    }
);

export const createDatasetDetails = createAsyncThunk(
    'dataset/mutate/create',
    async (dto, thunkAPI) => {
        try {
            const response = await apiClient.post('/api/v1/dataset', dto)
            return thunkAPI.fulfillWithValue(response.data.payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);

        }
    }
);

export const updateDatasetDetails = createAsyncThunk(
    'dataset/mutate/update',
    async ({datasetId, dto}, thunkAPI) => {
        try {
            const response = await apiClient.put(`/api/v1/dataset/${datasetId}`, dto);
            return thunkAPI.fulfillWithValue(response.data.payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const publishDataset = createAsyncThunk(
    'dataset/mutate/publish',
    async (datasetId, thunkAPI) => {
        try {
            const response = await apiClient.post(`/api/v1/dataset/${datasetId}/publish`);
            return thunkAPI.fulfillWithValue(response.data.payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const deActivateDataset = createAsyncThunk(
    'dataset/mutate/deActivate',
    async (datasetId, apiThunk) => {
        try {
            const response = await apiClient.post(`/api/v1/dataset/${datasetId}/deActivate`);
            return apiThunk.fulfillWithValue(response.data.payload);
        } catch (error) {
            return apiThunk.rejectWithValue(error.response.data);
        }
    }
);

export const reActivateDataset = createAsyncThunk(
    'dataset/mutate/reActivate',
    async (datasetId, apiThunk) => {
        try {
            const response = await apiClient.post(`/api/v1/dataset/${datasetId}/reActivate`);
            return apiThunk.fulfillWithValue(response.data.payload);
        } catch (error) {
            return apiThunk.rejectWithValue(error.response.data);
        }
    }
);


export const deleteDataset = createAsyncThunk(
    'dataset/mutate/delete',
    async (datasetId, thunkAPI) => {
        try {
            const response = await apiClient.delete(`/api/v1/dataset/${datasetId}`);
            return thunkAPI.fulfillWithValue(response.data.payload);
        } catch (error) {
            return  thunkAPI.rejectWithValue(error.response.data);
        }
    }
);
export const {clearDatasetDetails, clearDatasetList} = datasetAPI.actions;
export default datasetAPI.reducer;
